import React from "react";
import DealersHome from "./DealersHome";

/**
 * Dealers landing entry — unique trade-floor home (not marketplace clone).
 */
function Landingmain(props) {
  return <DealersHome {...props} />;
}

export default Landingmain;
